import { render } from "./ConstructionPermits.vue?vue&type=template&id=2b88987b&scoped=true"
import script from "./ConstructionPermits.vue?vue&type=script&lang=js"
export * from "./ConstructionPermits.vue?vue&type=script&lang=js"

import "./ConstructionPermits.vue?vue&type=style&index=0&id=2b88987b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b88987b"]])

export default __exports__